// extracted by mini-css-extract-plugin
module.exports = {"Item":"Item_Item__1myqt","Item-draggable":"Item_Item-draggable__2xydq","Item-dragging":"Item_Item-dragging__3J8t6","ItemHandle":"Item_ItemHandle__2Q0In"};